import React, {useState} from "react";
import { useProductionStore } from "../../../stores/production";
import { getColumnClass } from "../../../services/function";

const TimeSheet = () => {
const { production2 } = useProductionStore();
const [selectedCol, setSelectedCol] = useState<number | null>(null);
const days = production2?.times?.[0]?.departments?.[0]?.jours.length

// Fonction pour gérer le clic sur une colonne
const handleColumnClick = (columnIndex: number) => {
  setSelectedCol(columnIndex === selectedCol ? null : columnIndex);
};

  return (
    <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl mt-5">
      <thead className="h-12  sticky -top-1 bg-thead-dark border border-gray-300" >
        <tr className="font-bold">
          <th className="text-left px-4 font-bold ">Client</th>
          {Array.from({ length: days || 0 }, (_, index) => (
            <th key={index} className={getColumnClass(index, true, selectedCol) + "font-bold"} onClick={() => handleColumnClick(index)} style={{ cursor: 'pointer' }}>{index + 1}</th>
          ))}
          <th className="font-bold text-left px-4">Total</th>
        </tr>
      </thead>
      {production2?.times?.map((time: any, timeIndex: number) => (
        <React.Fragment key={time.id || `time-${timeIndex}`}>
          <thead className="h-12 mt-5" >
            <tr className="bg-thead">
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left font-semibold z-10">
                {time.client || 'Client'}
              </th>
              {Array.from({ length: days || 0 }, (_, index) => (
                <th key={index} className={getColumnClass(index, true, selectedCol)} onClick={() => handleColumnClick(index)} style={{ cursor: 'pointer' }}></th>
              ))}
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left font-bold">
                {time?.clientTotal}
              </th>
            </tr>
          </thead>
          <tbody>
            {time.departments?.map((department: any, deptIndex: number) => (
              <tr key={`${time.id || `time-${timeIndex}`}-${department.id || `dept-${deptIndex}`}`}>
                <td className="border border-gray-300 px-4 py-2 font-medium">
                  {department.type}
                </td>
                {Array.from({ length: days || 0 }, (_, index) => (
                  <td 
                    key={`${time.id || `time-${timeIndex}`}-${department.id || `dept-${deptIndex}`}-${index}`} 
                    className={`border border-gray-300 px-2 py-1 text-center ${selectedCol === index ? 'bg-blue-100' : ''}`}
                    onClick={() => handleColumnClick(index)}
                    style={{ cursor: 'pointer' }}
                  >
                    {department.jours?.[index] || ''}
                  </td>
                ))}
                <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-100">
                  {department.total}
                </td>
              </tr>
            ))}
          </tbody>
        </React.Fragment>
      ))}
      <tfoot>
        <tr>
          <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-100">
            Total
          </td>
          {Array.from({ length: days || 0 }, (_, index) => (
            <td 
              key={index + 1} 
              className={`border border-gray-300 px-2 py-1 text-center ${selectedCol === index ? 'bg-blue-100' : 'bg-gray-100'}`}
              onClick={() => handleColumnClick(index)}
              style={{ cursor: 'pointer' }}
            >
              {production2?.total[index] || ''}
            </td>
          ))}
          <td className="border border-gray-300 px-4 py-2 font-medium bg-gray-100">
            {production2.supertotal}
          </td>
        </tr>
      </tfoot>
    </table>
  )
}

export default TimeSheet